import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addPercentOffFlagToSalePageSelector = createSelector(testTargetOffersSelector, offers => offers.addPercentOffFlagToSalePage || Empty.Object);

export { addPercentOffFlagToSalePageSelector };
